<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 4.375C7 5.3415 6.2165 6.125 5.25 6.125C4.2835 6.125 3.5 5.3415 3.5 4.375C3.5 3.4085 4.2835 2.625 5.25 2.625C6.2165 2.625 7 3.4085 7 4.375ZM7 4.375C7 5.3415 7.7835 6.125 8.75 6.125C9.7165 6.125 10.5 5.3415 10.5 4.375C10.5 3.4085 9.7165 2.625 8.75 2.625C7.7835 2.625 7 3.4085 7 4.375ZM8.75 12.25C8.75 9.56315 7.55806 7.875 5.25 7.875C2.94194 7.875 1.75 9.63534 1.75 12.25H8.75ZM8.75 12.25H12.25C12.25 9.56315 11.0581 7.875 8.75 7.875C8.09767 7.875 7.5345 8.01562 7.0622 8.27639"
      stroke="var(--icon-border-default)"
      stroke-width="1.1"
    />
  </svg>
</template>
